export const jsonFormat = (value: unknown): string => {
  if (value === undefined || value === null) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  return JSON.stringify(value, null, 2);
};

export const jsonParseObject = (raw: string): Record<string, unknown> | string => {
  const trimmed = raw.trim();
  if (!trimmed) {
    return {};
  }
  try {
    return JSON.parse(trimmed) as Record<string, unknown>;
  } catch {
    return raw;
  }
};

export const jsonParseArray = (raw: string): unknown[] | string => {
  const trimmed = raw.trim();
  if (!trimmed) {
    return [];
  }
  try {
    return JSON.parse(trimmed) as unknown[];
  } catch {
    return raw;
  }
};

export const scheduleTypeChoices = [
  { id: 'flexible', name: 'flexible' },
  { id: 'manual', name: 'manual' },
  { id: 'planning_space', name: 'planning_space' },
  { id: 'regular', name: 'regular' },
  { id: 'shifts', name: 'shifts' }
];

export const recurrencePeriodChoices = [
  { id: 'daily', name: 'daily' },
  { id: 'weekly', name: 'weekly' }
];
